export const getFinalRisk = (risk) => {
    if (!risk)
        return undefined;
    return Object.entries(risk).find(([, value]) => value.final);
};
//# sourceMappingURL=risk.js.map